<template lang="pug">
  v-menu(
    v-model="menu"
    :disabled="disabled"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px")
    template(v-slot:activator="{ on }")
      ValidationProvider(:rules="rules" v-slot="{ errors }")
        v-text-field(
          v-model="dateFormatted"
          readonly
          :disabled="disabled"
          v-on="on"
          :error="errors.length > 0")
          template(v-slot:label)
            v-icon.pr-1(v-if="isRequired" color="red accent-2" size="12") mdi-asterisk
            v-icon.pr-1(:color="getColorError(errors.length)" size="22") mdi-calendar
            | {{ label }}
        span.red--text.text--accent-2(v-if="errors.length > 0")
          v-icon(color="red accent-2") mdi-alert
          |  {{ errors[0] }}
    v-date-picker(
      v-model="date"
      range
      no-title
      scrollable
      :locale="$i18n.locale"
      :first-day-of-week="1"
      @input="dateSelected()")
</template>

<script>
  export default {
    name: "BaseDatePickerRange",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Array,
        default: function(){
          return []
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      rules: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      }
    },
    data:() => ({
      menu: false,
      dateFormatted: null,
      date: [],
    }),
    computed: {
      isRequired(){
        return this.rules.includes('required');
      }
    },
    watch: {
      value: function(val){
        this.dateFormatted = val;
        if (val != null && val.length > 0) {
          this.date = [this.getFormatDate(val[0]), this.getFormatDate(val[1])];
        } else {
          this.date = [];
        }
      }
    },
    created(){
      this.dateFormatted = this.value;
      if (this.value != null && this.value.length > 0) {
        this.date = [this.getFormatDate(this.value[0]), this.getFormatDate(this.value[1])];
      }
    },
    methods:{
      getColorError(error){
        return error > 0 ? 'red accent-2' : '';
      },
      getFormatArrayDate(arraydate){
        return this.getFormatDateFormatted(arraydate[0]) + ' - ' + this.getFormatDateFormatted(arraydate[1]);
      },
      getFormatDateFormatted(date){
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      },
      getFormatDate(date){
        const [day, month, year] = date.split('/');
        return `${year}-${month}-${day}`;
      },
      dateSelected(){
        if(this.date.length == 2){
          this.menu = false;
          if(new Date(this.date[0]).getTime() < new Date(this.date[1]).getTime()){
            this.dateFormatted = this.getFormatArrayDate(this.date);
            this.$emit('input', [this.getFormatDateFormatted(this.date[0]), this.getFormatDateFormatted(this.date[1])]);
          } else {
            this.dateFormatted = this.getFormatArrayDate([this.date[1], this.date[0]]);
            this.$emit('input', [this.getFormatDateFormatted(this.date[1]), this.getFormatDateFormatted(this.date[0])]);
          }
        }
      },
    },
  }
</script>

<style lang="sass">
</style>